export const firebaseConfig = {
  apiKey: "AIzaSyDHTz4vXB3vb7_4PX5nMRsCvjjxPultciQ",
  authDomain: "contracts-46e8f.firebaseapp.com",
  projectId: "contracts-46e8f",
  storageBucket: "contracts-46e8f.appspot.com",
  messagingSenderId: "605964062386",
  appId: "1:605964062386:web:1e2f30a3da63cdcbce43ab",
  measurementId: "G-BCTSB4V5RK"
};